var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnSendInputText = function SvgBtnSendInputText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#btn_send_input_text_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 32,
    height: 32,
    rx: 6,
    transform: "rotate(-90 0 32)",
    fill: "#753BBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10v12m0-12 4 4m-4-4-4 4",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "btn_send_input_text_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgBtnSendInputText;